import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();

    // Show loading spinner while checking authentication
    if (loading) {
        return (
            <div className="auth-container">
                <div className="auth-form">
                    <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                        <div className="loading-spinner"></div>
                        <p style={{ marginTop: '20px', color: '#666' }}>
                            Checking authentication...
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    // If user is not authenticated, return null (parent will show auth forms)
    if (!user) {
        return null;
    }

    // User is authenticated, render the protected content
    return children;
};

export default ProtectedRoute; 